import { Tooltip } from "@material-ui/core";
import { stringToMask, toStringCurrency } from "helpers/string";
import ls from "Localization";
import React, { useMemo } from "react";
import { FaCloudUploadAlt, FaExternalLinkAlt, FaRegCopy } from "react-icons/fa";
import { MdOpenInNew } from "react-icons/md";
import { toast } from "react-toastify";
import { Badge, Card, Col, Container, Input, Row } from "reactstrap";
import { nfseStatus } from "types/nfseStatus";
import nfseServiceTypes from "../../../../assets/nfseServicetype.json";

const NFSE_PUBLIC_CONSULT_URL = "https://www.nfse.gov.br/consultapublica";

const DetailNFSe = ({ nfse, onChange }) => {
	const copyToClipboard = async text => {
		try {
			await navigator.clipboard.writeText(text);
			toast.success("Texto copiado para a área de transferência: " + text);
		} catch (err) {
			toast.warning("Falha ao copiar o texto");
			console.log("Falha ao copiar o texto", err);
		}
	};

	return (
		<div>
			<Card>
				<Container>
					<Row>
						<Col>
							<Row>
								<Col className="mt-3" xs={12} sm={12} md={6} xl={4}>
									<h4>
										<strong>Informações de Acesso</strong>
									</h4>
								</Col>
							</Row>
							<Row>
								<Col className="mt-3" xs={12} sm={12} md={6} xl={4}>
									<p>
										<strong>Login Prefeitura: </strong>
										<br />
										<span>{nfse?.mei?.nfEmissionLogin || "--"}</span>
									</p>
								</Col>
								<Col className="mt-3" xs={12} sm={12} md={6} xl={4}>
									<p>
										<strong>Password Prefeitura: </strong>
										<br />
										<span>{nfse?.mei?.nfEmissionPassword || "--"}</span>
									</p>
								</Col>
								<Col className="mt-3" xs={12} sm={12} md={6} xl={4}>
									<p>
										<strong>Url Prefeitura: </strong>
										<br />
										{nfse?.mei?.nfEmissionUrl || "--"}
									</p>
								</Col>

								{nfse?.code && (
									<Col className="mt-3" xs={12} sm={12} md={6} xl={4}>
										<p>
											<strong>Consulta Pública NFS-e: </strong>
											<br />
											<span
												style={{
													display: "inline-flex",
													alignItems: "center",
													gap: "8px"
												}}
											>
												<Tooltip
													title="Clique para copiar o código da NF para a área de transferência"
													placement="top"
												>
													<Badge
														color="primary"
														style={{ cursor: "pointer", fontSize: "12px" }}
														onClick={() => copyToClipboard(nfse.code)}
													>
														<FaRegCopy
															size={14}
															style={{ marginRight: "4px" }}
														/>
														{nfse.code.substring(0, 4)}...
														{nfse.code.substring(nfse.code.length - 4)}
													</Badge>
												</Tooltip>

												<Badge
													color="primary"
													href={NFSE_PUBLIC_CONSULT_URL}
													target="_blank"
													rel="noopener noreferrer"
													style={{ fontSize: "12px" }}
												>
													<FaExternalLinkAlt
														size={14}
														style={{ marginRight: "4px" }}
													/>
													Site da Consulta Pública
												</Badge>
											</span>
										</p>
									</Col>
								)}
							</Row>
							<Row>
								<Col className="mt-3" xs={12} sm={12} md={6} xl={4}>
									<h4>
										<strong>Informações</strong>
									</h4>
								</Col>
							</Row>
							<Row>
								<Col className="mt-3" xs={12} sm={12} md={6} xl={4}>
									<p>
										<strong>Status: </strong>
										<br />
										<span>{ls[nfseStatus[nfse?.status]]}</span>
									</p>
								</Col>
								<Col className="mt-3" xs={12} sm={12} md={6} xl={4}>
									<p>
										<strong>File: </strong>
										<br />
										{nfse?.file ? (
											<Badge
												color={"primary"}
												href={nfse.file}
												target={"_blank"}
											>
												Clique Aqui
											</Badge>
										) : (
											"--"
										)}
									</p>
								</Col>
								{nfse?.statusReason && (
									<Col className="mt-3" xs={12}>
										<p>
											<strong>Motivo do Status: </strong>
											<br />
											<span>{nfse?.statusReason}</span>
										</p>
									</Col>
								)}
							</Row>
							<Row>
								<Col className="mt-3" xs={12} sm={12} md={6} xl={4}>
									<h4>
										<strong>Emissor (Prestador de Serviço)</strong>
									</h4>
								</Col>
							</Row>
							<Row>
								<Col className="mt-3" xs={12} sm={12} md={6} xl={4}>
									<p>
										<strong>Nome da Empresa: </strong>
										<br />
										<span>
											<Badge
												style={{
													cursor: "pointer"
												}}
												color={"primary"}
												target={"_blank"}
												onClick={() => {
													let win = window.open(
														`/companies/${nfse.mei._id}`,
														"_blank"
													);
													win.focus();
												}}
												className={"mr-1"}
											>
												<MdOpenInNew size={16} />
											</Badge>{" "}
											{nfse.mei ? nfse?.mei.businessName : "--"}
										</span>
									</p>
								</Col>

								<Col className="mt-3" xs={12} sm={12} md={6} xl={4}>
									<p>
										<strong>CNPJ: </strong>
										<br />
										<span>
											{nfse?.mei?.cnpj
												? stringToMask(nfse?.mei?.cnpj, "cnpj")
												: "--"}
										</span>
									</p>
								</Col>

								<Col className="mt-3" xs={12} sm={12} md={6} xl={4}>
									<p>
										<strong>CNAE: </strong>
										<br />
										<span>
											<span>{nfse?.mei?.occupation || "--"}</span>
										</span>
									</p>
								</Col>
							</Row>

							<Row>
								<Col className="mt-3" xs={12} sm={12} md={6} xl={12}>
									<p>
										<strong>Atividade: </strong>
										<br />
										<span>
											<span>{nfse?.mei?.activity || "--"}</span>
										</span>
									</p>
								</Col>
							</Row>

							{nfse?.mei?.secondaryActivities &&
							nfse?.mei?.secondaryActivities.length > 0 ? (
								<Row>
									<Col className="mt-3" xs={12} sm={12} md={6} xl={12}>
										<strong style={{ color: "#646677" }}>
											Atividades Secundárias:
										</strong>
										<ul>
											{nfse.mei.secondaryActivities.map(activity => (
												<li key={activity}>
													<span style={{ color: "#646677" }}>{activity}</span>
												</li>
											))}
										</ul>
									</Col>
								</Row>
							) : (
								""
							)}

							<Row>
								<Col className="mt-3" xs={12} sm={12} md={6} xl={12}>
									<p>
										<strong>ENDEREÇO: </strong>
										<br />
										<span>
											{useMemo(() => {
												const address = nfse.mei?.address;

												if (!address) return "";

												const {
													street,
													number,
													complement,
													neighborhood,
													city,
													state,
													zipCode
												} = address;

												return `${street || ""}, ${number ||
													"sn"} - ${complement || ""}${
													complement ? " - " : ""
												}${neighborhood || ""} - ${city || ""} - ${state ||
													""} - ${zipCode || ""}`;
											}, [nfse])}
										</span>
									</p>
								</Col>
							</Row>

							<Row>
								<Col className="mt-3" xs={12} sm={12} md={6} xl={4}>
									<h4>
										<strong>Cliente (Tomador)</strong>
									</h4>
									<span>
										{nfse.client?.isExternal ? "*Contato Externo" : ""}
									</span>
								</Col>
							</Row>
							<Row>
								<Col className="mt-3" xs={12} sm={12} md={6} xl={4}>
									<p>
										<strong>Nome do Cliente: </strong>
										<br />
										<span>
											<span>
												{nfse.clientMei?._id && (
													<>
														<Badge
															style={{
																cursor: "pointer"
															}}
															color={"primary"}
															target={"_blank"}
															onClick={() => {
																let win = window.open(
																	`/companies/${nfse.clientMei._id}`,
																	"_blank"
																);
																win.focus();
															}}
															className={"mr-1"}
														>
															<MdOpenInNew size={16} />
														</Badge>{" "}
													</>
												)}
												{nfse?.clientMei?.businessName ||
													nfse?.client?.mei?.businessName ||
													nfse.client?.name}
											</span>
										</span>
									</p>
								</Col>
								<Col className="mt-3" xs={12} sm={12} md={6} xl={3}>
									<p>
										<strong>
											{nfse?.clientMei?.cnpj || nfse?.client?.mei?.cnpj
												? "CNPJ"
												: nfse?.client?.document &&
												  nfse?.client?.document.length == 11
												? "CPF"
												: "Documento"}{" "}
											Cliente:{" "}
										</strong>
										<br />
										<span>
											<span>
												{nfse?.clientMei?.cnpj || nfse?.client?.mei?.cnpj
													? stringToMask(
															nfse?.clientMei?.cnpj || nfse?.client?.mei?.cnpj,
															"cnpj"
													  )
													: nfse?.client?.document}
											</span>
										</span>
									</p>
								</Col>
							</Row>
							<Row>
								<Col className="mt-3" xs={12} sm={12} md={6} xl={3}>
									<h4>
										<strong>Contato Financeiro Cliente</strong>
									</h4>
								</Col>
							</Row>
							<Row>
								<Col className="mt-3" xs={12} sm={12} md={6} xl={4}>
									<p>
										<strong>Email do Cliente: </strong>
										<br />
										<span>
											<span>
												{nfse?.contactCompany?.email ||
													nfse?.client?.mei?.email ||
													nfse?.client?.email}
											</span>
										</span>
									</p>
								</Col>
								<Col className="mt-3" xs={12} sm={12} md={6} xl={4}>
									<p>
										<strong>Telefone do Cliente: </strong>
										<br />
										<span>
											<span>
												{nfse?.contactCompany?.phone || nfse?.client?.phone}
											</span>
										</span>
									</p>
								</Col>
							</Row>
							<Row>
								<Col className="mt-3" xs={12} sm={12} md={6} xl={12}>
									<p>
										<strong>ENDEREÇO: </strong>
										<br />
										<span>
											{useMemo(() => {
												const address =
													nfse.contactCompany?.address ||
													nfse.client?.mei?.address ||
													nfse.client?.address;

												if (!address) return "";

												const {
													street,
													number,
													complement,
													neighborhood,
													city,
													state,
													zipCode
												} = address;

												return `${street || ""}, ${number ||
													"sn"} - ${complement || ""}${
													complement ? " - " : ""
												}${neighborhood || ""} - ${city || ""} - ${state ||
													""} - ${zipCode || ""}`;
											}, [nfse])}
										</span>
									</p>
								</Col>
							</Row>
							<Row>
								<Col className="mt-3" xs={12} sm={12} md={6} xl={4}>
									<h4>
										<strong>Descrição NFS-e</strong>
									</h4>
								</Col>
							</Row>
							<Row>
								<Col className="mt-3" xs={12} sm={12} md={6} xl={4}>
									<p>
										<strong>Tipo do Serviço </strong>
										<br />
										<span>
											<span>
												{(nfse?.serviceType &&
													nfseServiceTypes
														.find(c => nfse.serviceType.startsWith(c.code))
														?.items.find(c => c.code === nfse.serviceType)
														?.value) ||
													"Não informado"}
											</span>
										</span>
									</p>
								</Col>

								<Col className="mt-3" xs={12} sm={12} md={6} xl={4}>
									<p>
										<strong>Descrição </strong>
										<br />
										<span>
											<span>{nfse?.service ? nfse?.service : ""}</span>
										</span>
									</p>
								</Col>
								<Col className="mt-3" xs={12} sm={12} md={6} xl={4}>
									<p>
										<strong>Observação </strong>
										<br />
										<span>
											<span>
												{nfse?.observations ? nfse?.observations : ""}
											</span>
										</span>
									</p>
								</Col>
								<Col className="mt-3" xs={12} sm={12} md={6} xl={4}>
									<p>
										<strong>Valor </strong>
										<br />
										<span>
											<span>
												{nfse?.totalValue
													? toStringCurrency(+nfse?.totalValue / 100.0)
													: "--"}
											</span>
										</span>
									</p>
								</Col>
								<Col className="mt-3" xs={12} sm={12} md={6} xl={4}>
									<p>
										<strong>Data da Solicitação </strong>
										<br />
										<span>
											<span>{nfse?.createdAt ? nfse?.createdAt : "--"}</span>
										</span>
									</p>
								</Col>
								<Col className="mt-3" xs={12} sm={12} md={6} xl={4}>
									<p>
										<strong>Lançamento Financeiro? </strong>
										<br />
										<span>
											<span>{nfse?.generateFinancial ? "Sim" : "--"}</span>
										</span>
									</p>
								</Col>
							</Row>
						</Col>
						{nfse?.file ? (
							<Col className="mt-3" xs={12} sm={12} md={6} xl={6}>
								<object data={nfse?.file} width="100%" height="100%"></object>
							</Col>
						) : (
							<Col
								xs={12}
								sm={12}
								md={6}
								xl={6}
								className="d-flex justify-content-center align-items-center"
							>
								<Row>
									<Col>
										<FaCloudUploadAlt
											size={150}
											style={{
												color: "#504c9a"
											}}
										/>
										<Input
											id="exampleFile"
											name="file"
											type="file"
											onChange={onChange}
										/>
									</Col>
								</Row>
								<Row></Row>
							</Col>
						)}
					</Row>
				</Container>
			</Card>
		</div>
	);
};

export default DetailNFSe;
